import { render, staticRenderFns } from "./BlockCustomTable.vue?vue&type=template&id=2ad004ba&"
import script from "./BlockCustomTable.vue?vue&type=script&lang=js&"
export * from "./BlockCustomTable.vue?vue&type=script&lang=js&"
import style0 from "./BlockCustomTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports